import type { ThreadLista } from '../api/types';

export type SortFunc = (thr: ThreadLista) => number
export const empty_initial_values: FormValues = {
  categorie: [], eventi: [], solo_non_assegnati: true, mostra_scartati_duplicati: false,
  categorieevento: [], ricerca_diretta: "",
}

export interface FormValues {
  categorie: number[],
  eventi: string[],
  categorieevento: number[],
  solo_non_assegnati: boolean,
  mostra_scartati_duplicati: boolean,
  ricerca_diretta: string,
}

type FilterPipeline = (prob: ThreadLista) => boolean;

const get_pipeline = (login: { user: { id: number } }, params: { pk?: string }, location: { pathname: string }, values: FormValues) => {
  const pipeline: FilterPipeline[] = [];

  let categorie: number[];
  let categorieevento: number[];
  const eventi = values.eventi.map(val => parseInt(val));

  // Categorie
  if (location.pathname.match(/thread\/problema\/categoria\//g)) {
    categorie = [parseInt(params.pk as string),]
  } else {
    categorie = values.categorie;
  }

  // Categoria evento
  if (location.pathname.match(/thread\/problema\/categoria-evento/g)) {
    categorieevento = [parseInt(params.pk as string),]
  } else {
    categorieevento = values.categorieevento.map(Number);
  }

  // Assegnati a me
  if (location.pathname.match(/thread\/problema\/assegnati/g)) {
    pipeline.push(thr => thr.problema.correttori_assegnati.includes(login.user.id));
  }

  // Proposti da me
  if (location.pathname.match(/thread\/problema\/miei/g)) {
    pipeline.push(thr => thr.problema.propositore == login.user.id)
  }

  for (const c of categorie) {
    pipeline.push(thr => thr.problema.categoria.includes(c))
  }
  if (eventi.length > 0) {
    pipeline.push(thr => eventi.filter(ev => thr.problema.evento_assegnato == ev).length > 0)
  }
  if (categorieevento.length > 0) {
    pipeline.push(thr => categorieevento.filter(ev => thr.problema.eventi_proposto.includes(ev)).length > 0)
  }
  if (values.solo_non_assegnati) {
    pipeline.push(thr => thr.problema.evento_assegnato === null)
  }
  if (!values.mostra_scartati_duplicati) {
    pipeline.push(thread => {
      if (!thread.problema.flags_smistatore) return true;
      const { flag } = thread.problema.flags_smistatore;
      return flag != "d" && flag != "s"
    })
  }
  return pipeline;
}

export const filtra = (login: { user: { id: number } }, params: { pk?: string }, location: { pathname: string }, values: FormValues, lista: ThreadLista[], sortFun: SortFunc | null, order: number, pkList: number[] | null) => {
  const pipeline = get_pipeline(login, params, location, values);
  if (pkList !== null) {
    pipeline.push(thr => pkList.includes(thr.problema.id))
  }

  let nuovo = [...lista];
  for (const elem of pipeline) {
    nuovo = nuovo.filter(elem);
  }
  if (sortFun) nuovo.sort((a, b) => (order * (sortFun(a) - sortFun(b))));
  return nuovo;
}
